import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './Toggle.styles.js';

const Toggle = ({ disabled, checked, onChange, size, children, onClick }) => {
  const [isChecked, setChecked] = useState(checked);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  const handleChange = ({ target: { checked } }) => {
    if (onChange) {
      setChecked(checked);
      onChange(checked);
    }
  };

  const handleClick = ({ target: { checked } }) => {
    onClick && onClick(checked);
  };

  return (
    <S.Toggle>
      <S.ToggleWrapper disabled={disabled}>
        {children}
        <S.ToggleSwitch size={size}>
          <S.ToggleCheckbox
            disabled={disabled}
            checked={isChecked}
            onChange={handleChange}
            onClick={handleClick}
          />
          <S.Switch size={size} />
        </S.ToggleSwitch>
      </S.ToggleWrapper>
    </S.Toggle>
  );
};

Toggle.defaultProps = {
  disabled: false,
  checked: false,
  size: 'sm',
};

Toggle.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default Toggle;
